module.exports = __webpack_public_path__ + "media/brands/maruti-e76559fa.png";